import { render, staticRenderFns } from "./UnsanitaryTypeRegister.vue?vue&type=template&id=237d6130"
import script from "./UnsanitaryTypeRegister.vue?vue&type=script&lang=js"
export * from "./UnsanitaryTypeRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237d6130')) {
      api.createRecord('237d6130', component.options)
    } else {
      api.reload('237d6130', component.options)
    }
    module.hot.accept("./UnsanitaryTypeRegister.vue?vue&type=template&id=237d6130", function () {
      api.rerender('237d6130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/discipline/UnsanitaryTypeRegister.vue"
export default component.exports